class Citation {
  constructor(citation = {}) {
    this.wos = citation.wos;
    this.scopus = citation.scopus;
  }
}

export default Citation;
